import React, { Component } from 'react';
import SpiceItemComponent from '../components/spice/spice.item.component';
class SpiceContainer extends Component {
  render() {
    return (
      <section className={this.props.className}>
        <SpiceItemComponent title={this.props.title} description={this.props.description} />
      </section>
    );
  }
}

export default SpiceContainer;



// WEBPACK FOOTER //
// ./src/containers/spice.container.jsx